<template>
  <router-view id="app"></router-view>
</template>

<script>
  export default { };
</script>
